import { OpView } from 'src/assets/icons';
import { OpIconButton } from 'src/components';

function UsageDetailsCell({ onClick, isDisabled }: { onClick: () => void; isDisabled?: boolean }) {
  return <OpIconButton title={''} svgUrl={OpView} onClick={onClick} isDisabled={isDisabled} />;
}

export default UsageDetailsCell;
